import useTranslate from 'app/i18n/useTranslate';

type DriverSource = 'FORMULA' | 'LABEL_MINIMUM' | 'HARDNESS_FLOOR';

const useTranslation = () => {
    const t = useTranslate('compatibilityAdvisoryPanel');

    return {
        AMS_TITLE: t('amsTitle'),
        CITATION_LINK: t('citationLink'),
        CLEAN_MESSAGE: t('cleanMessage'),
        DEFAULT_WATER_PROFILE_NOTICE: t('defaultWaterProfileNotice'),
        ERROR_MESSAGE: t('errorMessage'),
        LOADING: t('loading'),
        PH_TITLE: (count: number): string => t('phTitle', { count: String(count) }),
        TITLE: t('title'),
        amsDriver: (driver: string): string => t('amsDriver', { driver }),
        amsRecommendationText: (amount: string): string => t('amsRecommendationText', { amount }),
        driverLabel: (source: DriverSource): string => t(`driverLabels.${source}`),
        interactionsTitle: (count: number): string =>
            t('interactionsTitle', { count: String(count) }),
        pairDescription: (firstName: string, secondName: string, interactionType: string): string =>
            t('pairDescription', { firstName, interactionType, secondName }),
        phAbove: (threshold: string, observed: string): string =>
            t('phAbove', { observed, threshold }),
        phBelow: (threshold: string, observed: string): string =>
            t('phBelow', { observed, threshold })
    };
};

export default useTranslation;
